import styled from 'styled-components';
import { Button } from 'shared/components/Button';
import { Modal } from 'shared/components/Modal';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.Tabs.CnidInfoModal';

export const CnidInfoModal = ({ onOkClick, onClose }) => (
  <CnidInfoModal.Modal
    data-qa="checkout_cnid_info_modal"
    onClose={onClose}
    title={t('checkout.cnidInfoModalTitle', 'Chinese ID Card')}
  >
    <CnidInfoModal.ModalText>
      {t(
        `${TP}.cnidInfoModalText`,
        'If you are a citizen of Mainland China, please add your Chinese identity card number to enjoy faster shipping and a lower tax rate.',
      )}
    </CnidInfoModal.ModalText>
    <CnidInfoModal.Okay inverted data-qa="checkout_cnid_info_modal_confirm" onClick={onOkClick}>
      {t(`${TP}.modalOkButton`, 'Okay')}
    </CnidInfoModal.Okay>
  </CnidInfoModal.Modal>
);

CnidInfoModal.Modal = styled(Modal)`
  max-width: 335px;
`;

CnidInfoModal.ModalText = styled.p`
  margin: 0;
  padding: 8px 0;
`;

CnidInfoModal.Okay = styled(Button)`
  font-size: 9.5px;
  width: 100%;
  text-transform: uppercase;
  margin-top: 32px;
`;
